import {ApplicationInsights} from '@microsoft/applicationinsights-web'

export default defineNuxtPlugin(nuxtApp => {
  const runtimeConfig = useRuntimeConfig()
  const searchInsights = new ApplicationInsights({config: {
    connectionString: runtimeConfig.public.SEARCH_INSIGHTS_CONNECTION_STRING,
    disableAjaxTracking: true,
    disableExceptionTracking: true,
    disableFetchTracking: true,
    disableTelemetry: true
  }})
  searchInsights.loadAppInsights()
  searchInsights.addTelemetryInitializer((envelope) => {
    if (envelope?.baseType === 'ExceptionData') {
      const message = envelope?.baseData?.exceptions?.[0]?.message || ''
      if (message.includes('ResizeObserver loop')) {
        return false // Drop this telemetry item
      }
    }
    return true
  })
  nuxtApp.provide('searchInsights', searchInsights)
})
